import {HttpClient, HttpContext, HttpErrorResponse, HttpEvent, HttpEventType, HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";
import {FactoryProvider, Inject, Injectable} from "@angular/core";
import {
    AksjeeierbokRessursClient, AksjeeierRessursClient, AksjeklasseRessursClient, ArkivRessursClient, AsynkOppgaveRessursClient, AutentiseringRessursClient, AvstemningRessursClient, AvtaleRessursClient, BeslutningRessursClient, BrukerRessursClient, CriiptoOIDCRessursClient, DokumentRessursClient, DokumentsigneringRessursClient, FavorittRessursClient, FellesAutentiseringRessursClient, GruppeInvitasjonRessursClient, GruppeMedlemRessursClient, GruppeRessursClient, HttpClient as HttpClientI, KommentarRessursClient, LoggerRessursClient, LoggingRessursClient, MalmøteRessursClient, MedlemsRolleRessursClient, MetrikkerRessursClient, MigreringerRessursClient, MøtedeltakerRessursClient, MøteRessursClient, MøtetranskripsjonRessursClient, OppgaveRessursClient, OtpOppsettRessursClient, PlanRessursClient, ProtokollRessursClient, RestResponse, RevisjonsloggRessursClient, SakRessursClient, SakSkyfilOpplastingRessursClient, SakstypeRessursClient, SkatteetatenAksjeeierbokRessursClient, SkjemalåsRessursClient, SpørreskjemaAdministrasjonRessursClient, SpørreskjemaRessursClient, SpørreundersøkelseRessursClient, SystemmeldingRessursClient, SøkRessursClient, TemaRessursClient, ÅrshjulRessursClient
} from "./generertNg2HttpKlient";
import {map, tap} from 'rxjs/operators';
import {catchError, filter, firstValueFrom, Observable} from "rxjs";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MeldingTilBruker, Varighet} from "felles/tjenester/MeldingTilBruker";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {ajs_$log_DI_TOKEN, AjsLogService} from "web-ng2/tjenester/ajs/AjsLogService";
import {nyUuid} from "felles-ng2/støttefunksjoner/uuidGenerator";
import {standardFeilmeldingerForErrorRespons} from "felles-ng2/tjenester/ressurser/feilhåndtering";
import {I18nTekstMuligNull, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {erStreng} from "felles-ng2/støttefunksjoner/strenger";
import {feilkodeSomKunLoggesTilKonsoll} from "felles/infrastruktur/Logging";
import {StandardRequestHeadere} from "felles/infrastruktur/StandardRequestHeadereInterceptorAvhengigheter";

const debug = initDebugger('AngularHttpKlient');

/**
 *  Implementasjon av {@link  HttpClient} som benytter ng2's {@link HttpClient} for å utføre ressurs-kallene.
 *  Se tasken genererTypescriptRessursKlienterForNg2 i lederplan-tjenester/build.gradle for hvordan generertHttpKlient.ts
 *  genereres.
 */
@Injectable({providedIn: 'root'})
export class AngularHttpKlient implements HttpClientI {

    /** Definerer alle genererte ressurs-klasser som ng2 injiserbare tjenester. */
    static ng2ServiceProviders(): FactoryProvider[] {
        return [
            AngularHttpKlient.pakkRessursklasseSomFactory(AksjeeierbokRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(AksjeeierRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(AksjeklasseRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(SkatteetatenAksjeeierbokRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(ArkivRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(AsynkOppgaveRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(AutentiseringRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(AvstemningRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(AvtaleRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(BeslutningRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(BrukerRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(CriiptoOIDCRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(DokumentRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(DokumentsigneringRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(FavorittRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(FellesAutentiseringRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(GruppeInvitasjonRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(GruppeMedlemRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(GruppeRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(KommentarRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(LoggerRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(LoggingRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(MalmøteRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(MedlemsRolleRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(MetrikkerRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(MigreringerRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(MøteRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(MøtedeltakerRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(MøtetranskripsjonRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(OppgaveRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(OtpOppsettRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(PlanRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(ProtokollRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(RevisjonsloggRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(SakRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(SakSkyfilOpplastingRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(SakstypeRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(SkjemalåsRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(SystemmeldingRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(SøkRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(TemaRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(ÅrshjulRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(SpørreskjemaAdministrasjonRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(SpørreskjemaRessursClient),
            AngularHttpKlient.pakkRessursklasseSomFactory(SpørreundersøkelseRessursClient)
        ]
    }

    static pakkRessursklasseSomFactory(ressursklasse: any): FactoryProvider {
        return {
            provide: ressursklasse,
            useFactory: (httpClient: AngularHttpKlient) => new ressursklasse(httpClient),
            deps: [AngularHttpKlient]
        };
    }

    constructor(private $http: HttpClient, private oversettelser: Oversettelser, private meldingTilBruker: MeldingTilBruker, @Inject(ajs_$log_DI_TOKEN) private $log: AjsLogService) {
    }

    /** Utfører http kall.
     * Kaller er ansvarlig for å håndtere eventuell request-feil.
     * <pre>
     * MERK: http-kallet blir ikke utført før kaller av metoden kaller subscribe på returnert observable!
     * MERK: dersom du kaller subscribe multiple ganger blir http-kallet uført MULTIPLE ganger - uheldig for POST/PUT req.
     * MERK: dersom requestSpesifikasjon.options.rapporterProgresjon == true vil
     * </pre> */
    request<R>(requestSpesifikasjon: RequestSpesifikasjon<R>): RestResponse<R> {
        requestSpesifikasjon.url = `/api/${requestSpesifikasjon.url}`;
        const forespørselId = nyUuid();
        this.logRequest(requestSpesifikasjon, forespørselId)

        const respons = this.$http.request<R>(requestSpesifikasjon.method, requestSpesifikasjon.url, this.somHttpRequestOptionsMedForespørselIdHeader(requestSpesifikasjon, forespørselId))
          .pipe(tap(respons => this.logRespons(respons, requestSpesifikasjon, forespørselId)));
        return new AngularRequestRespons(respons, (feil, brukerrettetMelding) => this.håndterFeil(feil, brukerrettetMelding));
    }

    //private hjelpemetoder

    /** Viser feilmelding til bruker, logger feilen */
    private håndterFeil(feil: HttpErrorResponse, brukerrettetMelding: I18nTekstMuligNull) {
        const melding = brukerrettetMelding(this.oversettelser);
        if (erIkkeNil(melding))
            this.meldingTilBruker.feilmelding(melding, Varighet.timeout, undefined, false)
        this.logFeil(feil, melding);
    }

    private logFeil(feil: HttpErrorResponse, brukerrettetMelding: string | null): void {
        try {
            if (feilkodeSomKunLoggesTilKonsoll(feil)) console.error(`AngularHttpKlient.request, feil:${feil.status} (${feil.statusText}), url:${feil.url}, brukerrettetMelding:${brukerrettetMelding}`, feil);
            //normalt forventer vi en HttpErrorResponse, men vi har ingen garanti...
            else if (erIkkeNil(feil.status)) this.$log.error(`AngularHttpKlient.request, feil:${feil.status} (${feil.statusText}), url:${feil.url}, brukerrettetMelding:${brukerrettetMelding}`);
            else this.$log.error(`AngularHttpKlient.request, feil:${JSON.stringify(feil)}, brukerrettetMelding:${brukerrettetMelding}`);
        } catch (e) {
            this.$log.error(`AngularHttpKlient.logFeil, feil ved prosessering av feilmelding, ${e}`);
        }
    }

    private somHttpRequestOptionsMedForespørselIdHeader<T>(requestSpesifikasjon: RequestSpesifikasjon<T>, forespørselId: string): HttpRequestOptions {
        var headere = requestSpesifikasjon.options?.headere ?? new HttpHeaders();
        headere = headere.set(StandardRequestHeadere.lpForespoerselId, forespørselId);
        return {
            body: requestSpesifikasjon.data,
            params: requestSpesifikasjon.queryParams,
            headers: headere,
            observe: 'events',
            reportProgress: requestSpesifikasjon.options?.rapporterProgresjon === true
        };
    }

    private logRequest(requestSpesifikasjon: RequestSpesifikasjon<any>, forespørselId: string) {
        debug(`initierer kall ${requestSpesifikasjon.method} ${requestSpesifikasjon.url} (${StandardRequestHeadere.lpForespoerselId}:${forespørselId})`, requestSpesifikasjon);
    }

    private logRespons(respons: HttpEvent<any>, requestSpesifikasjon: RequestSpesifikasjon<any>, forespørselId: string) {
        debug(`respons fra ${requestSpesifikasjon.method} ${requestSpesifikasjon.url} (${StandardRequestHeadere.lpForespoerselId}:${forespørselId})`, respons);
    }
}

/** Requestdefinisjonen ressursmetodene kaller {@link AngularHttpKlient#request} med. */
interface RequestSpesifikasjon<R> {
    method: 'DELETE' | 'GET' | 'POST' | 'PUT' | 'HEAD' | 'JSONP' | 'OPTIONS';
    url: string;
    queryParams?: any;
    data?: any;
    copyFn?: (data: R) => R; //denne er definert av HttpClient interface def som typescript-generator lager, men vi benytter den ikke..
    options?: RequestValg;
}

/** Ekstra attributter som kaller av ressursmetoder kan angi ved kall.
 * Propageres til {@link AngularHttpKlient#request} via {@link RequestSpesifikasjon#options}. */
export interface RequestValg {
    headere?: HttpHeaders;
    rapporterProgresjon?: boolean;
}

/** Valg som {@link HttpClient#request} godtar */
//klarer ikke å ekstrahere parameter-definisjonen til aktuell HttpClient.request variant vhja ts Parameters<..>
//det nærmeste vi kommer er 'type HttpRequestOptions = Parameters<HttpClient["request"]>[2]' men denne def er fortsatt for vid
//har derfor kopiert relevant definisjon fra lederplan-klient/node_modules/@angular/common/http/index.d.ts
interface HttpRequestOptions {
    body?: any;
    headers?: HttpHeaders | {
        [header: string]: string | string[];
    };
    context?: HttpContext;
    reportProgress?: boolean;
    observe: 'events';
    params?: HttpParams | {
        [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };
    responseType?: 'json';
    withCredentials?: boolean;
}

/**
 * Wrapper rundt en observerbar http-respons.
 * Merk at bakenforliggende request ikke blir kjørt før 'subscribe(..)' kalles på
 * angitt 'respons'.
 * Ved request-feil vil angitt {@link #vedFeil} kalles for å vise brukerrettet feilmelding.
 */
export interface RequestRespons<T> {

    /** Promise som leverer den deserialiserte json-strukturen i responsen fra server. */
    somPromise(): Promise<T>;

    /** Promise som leverer den deserialiserte json-strukturen i responsen fra server.
     *
     * Ved request-feil vises melding returnert av angitt 'meldingVedFeil vhja {@link MeldingTilBruker}-tjenesten'.
     *
     * Dersom feilmelding angis som streng må du huske å omsluttet strengen med i18n(...),
     * eks: somPromiseVisStandardMeldingVedFeil(i18n('en feilmeldingstekst')), for at teksten skal bli plukket opp
     * av generer-pot-jobbene.
     *
     * Merk at feilen propageres fortsatt via returnert promise.catch */
    somPromiseVisMeldingVedFeil(meldingVedFeilSomTekstmal: string): Promise<T>;

    somPromiseVisMeldingVedFeil(meldingVedFeil: BrukerrettetFeilmelding): Promise<T>;

    /** Promise som leverer den deserialiserte json-strukturen i responsen fra server.
     *
     * Ved request-feil vises melding returnert av angitt 'meldingVedFeil' vhja {@link MeldingTilBruker}-tjenesten,
     * og angitt 'verdiVedFeil' vil bli returnert til kaller.
     *
     * Dersom feilmelding angis som streng må du huske å omsluttet strengen med i18n(...),
     * eks: somPromiseVisStandardMeldingVedFeil(i18n('en feilmeldingstekst')), for at teksten skal bli plukket opp
     * av generer-pot-jobbene.
     *
     * Merk at feilen IKKE propageres til kaller da angitt 'meldingVedFeil' vil bli returnert */
    somPromiseVisMeldingVedFeilOgReturnerVerdi<R>(meldingVedFeilSomTekstmal: string, verdiVedFeil: R): Promise<T | R>;

    somPromiseVisMeldingVedFeilOgReturnerVerdi<R>(meldingVedFeil: BrukerrettetFeilmelding, verdiVedFeil: R): Promise<T | R>;

    /** Promise som leverer den deserialiserte json-strukturen i responsen fra server.
     *
     * Ved request-feil vises standard feilmelding dersom slik finnes for aktuell responsfeil,
     * ellers melding returnert av angitt 'meldingVedFeil', vhja {@link MeldingTilBruker}-tjenesten.
     *
     * Dersom feilmelding angis som streng må du huske å omsluttet strengen med i18n(...),
     * eks: somPromiseVisStandardMeldingVedFeil(i18n('en feilmeldingstekst')), for at teksten skal bli plukket opp
     * av generer-pot-jobbene.
     *
     * Se {@link standardFeilmeldingerForErrorRespons} for standard feilmeldinger.
     * Merk at feilen propageres fortsatt via returnert promise.catch */
    somPromiseVisStandardMeldingVedFeil(meldingVedFeilSomTekstmal: string): Promise<T>;

    somPromiseVisStandardMeldingVedFeil(meldingVedFeil: BrukerrettetFeilmelding): Promise<T>;

    /**
     * Observable som leverer den deserialiserte json-strukturen i responsen fra server.
     *
     * Returnert Observable vil kun levere én verdi, og så lukkes.
     *
     * Ved ikke-200 respons vil feil leveres via subscribe.error / pipe(catchError)
     */
    somObservable(): Observable<T>;

    /**
     * Observable som leverer {@link HttpResponse} som representerer responsen fra server.
     *
     * Returnert Observable vil kun levere én verdi, og så lukkes.
     *
     * Ved ikke-200 respons vil feil leveres via subscribe.error / pipe(catchError)
     */
    råRespons(): Observable<HttpResponse<T>>;

    /**
     * Observable som leverer {@link HttpEvent} som representerer responsen fra server.
     *
     * Returnert Observable leverer multiple verdier, og avslutter med en HttpResponse
     * hvorpå den lukkes.
     * Bruk {@link HttpEvent#type} for å skille mellom de ulike HttpEvent-typene.
     *
     * Ved ikke-200 respons vil feil leveres via subscribe.error / pipe(catchError)
     */
    råEventer(): Observable<HttpEvent<T>>;
}

/** Callback som kalles av AngularRequestRespons feilhåndteringskode for å vise brukerrettet feilmelding. */
export type VedFeil = (
  /** Den aktuelle http-request-feilen. Se `httpErrorResponseTyper.ts` for metoder for avgjøre feiltype. */
  feil: HttpErrorResponse,
  /** Metode som returnerer brukerrettet feilmelding, dersom denne returnerer null vises ingen melding */
  brukerrettetMelding: I18nTekstMuligNull
) => void;

/** Metode som returnerer brukerrettet feilmelding for angitt feil */
export type BrukerrettetFeilmelding = (feil: HttpErrorResponse, oversettelser: Oversettelser) => string | null;

export class AngularRequestRespons<T> implements RequestRespons<T> {

    /** BrukerrettetFeilmelding definisjon som returnerer null og som dermed sørger for at ingen melding vises til bruker. */
    static utenBrukerrettetFeilmelding: BrukerrettetFeilmelding = () => null;

    constructor(private readonly respons: Observable<HttpEvent<T>>,
                /** callback for visning av feilmelding */
                private readonly vedFeil: VedFeil) {
    }

    somPromise(): Promise<T> {
        return firstValueFrom(this.somObservable());
    }

    somPromiseVisMeldingVedFeil(meldingVedFeil: BrukerrettetFeilmelding | string): Promise<T> {
        return this.somPromiseVisFeilmelding(meldingVedFeil, false);
    }

    somPromiseVisMeldingVedFeilOgReturnerVerdi<R>(meldingVedFeil: BrukerrettetFeilmelding | string, verdiVedFeil: R): Promise<T | R> {
        return this.somPromiseVisFeilmelding(meldingVedFeil, false).catch(() => verdiVedFeil);
    }

    somPromiseVisStandardMeldingVedFeil(meldingVedFeil: BrukerrettetFeilmelding | string): Promise<T> {
        return this.somPromiseVisFeilmelding(meldingVedFeil, true);
    }

    somObservable(): Observable<T> {
        return this.responsdata(AngularRequestRespons.utenBrukerrettetFeilmelding, false);
    }

    råRespons(): Observable<HttpResponse<T>> {
        return this.respons
          .pipe(filter(event => event.type == HttpEventType.Response));
    }

    råEventer(): Observable<HttpEvent<T>> {
        return this.respons
    }

    //private hjelpemetoder

    private somPromiseVisFeilmelding(meldingVedFeil: BrukerrettetFeilmelding | string, standardFeilmeldingerAktivert: boolean): Promise<T> {
        if (erStreng(meldingVedFeil)) meldingVedFeil = statiskMelding(meldingVedFeil);
        return firstValueFrom(this.responsdata(meldingVedFeil, standardFeilmeldingerAktivert));
    }

    private responsdata(meldingVedFeil: BrukerrettetFeilmelding, standardFeilmeldingerAktivert: boolean): Observable<T> {
        return this.råRespons()
          .pipe(
            catchError((feil: HttpErrorResponse) => {
                this.håndterFeil(feil, meldingVedFeil, standardFeilmeldingerAktivert);
                throw feil; //sørger for at kaller fortsatt blir informert om feilen
            }),
            //vi antar at body aldri er null
            map(respons => respons.body!)
          );
    }

    /** Håndterer request feil ved å generer feilmelding og vise denne vhja kall til {@link #vedFeil} */
    private håndterFeil(errorRespons: HttpErrorResponse, meldingVedFeil: BrukerrettetFeilmelding, standardFeilmeldingerAktivert: boolean) {
        const melding: I18nTekstMuligNull = oversettelser => standardFeilmeldingerAktivert ?
          this.standardFeilmelding(errorRespons, meldingVedFeil, oversettelser) :
          meldingVedFeil(errorRespons, oversettelser);
        this.vedFeil(errorRespons, melding);
    }

    /** Generer feilmelding.
     * Dersom standard feilmelding er definert for angitt errorRespons benyttes denne, ellers benyttes feilmelding definert av kaller. */
    private standardFeilmelding(errorRespons: HttpErrorResponse, meldingVedFeil: BrukerrettetFeilmelding, oversettelser: Oversettelser): string | null {
        const standardMelding = standardFeilmeldingerForErrorRespons(errorRespons)?.oversett(oversettelser);
        return erIkkeNil(standardMelding) ? standardMelding : meldingVedFeil(errorRespons, oversettelser);
    }

}

export function statiskMelding(tekstmal: string): BrukerrettetFeilmelding {
    return (errorRespons, oversettelser) => oversettelser.oversett(tekstmal);
}
